import React, { useEffect, useRef, useState } from 'react';
import { getUserActivityLogs } from '../../utils/urls';
import { useSelector } from 'react-redux';
import axios from '../../utils/axios';
import FlexComponent from '../../components/FlexComponent';
import adminLogo from '../../Images/admin_img.jpg';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner'; // ← added
import UserActivityLog from '../../components/apps/UserActivityLog';

function UserActivityLogs() {
    const userId = useSelector((state) => state.user.userId);
    const isSuperuser = useSelector((state) => state.user.isSuperuser);
    const image = useSelector((state) => state.user.image);

    const [activityLogs, setActivityLogs] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [dateRange, setDateRange] = useState(null);
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [loading, setLoading] = useState(false); // ← new state for loading

    const toast = useRef(null);

    const formatDate = (date) => {
        if (!date) return '';
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    const fetchActivityLogs = async (start, end) => {
        if (!userId || !start || !end) return;

        setLoading(true); // ← start loading

        try {
            const url = `${getUserActivityLogs}?startTime=${start}&endTime=${end}`;
            const response = await axios.get(url, {
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.status === 200) {
                const data = response.data.activity || [];
                setActivityLogs(data);
            }
        } catch (error) {
            console.error('Error fetching user activity logs:', error);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load activity logs',
                    life: 4000,
                });
            }
        } finally {
            setLoading(false); // ← stop loading (success or error)
        }
    };

    // Default: today on first mount
    useEffect(() => {
        const today = new Date();
        const todayStr = formatDate(today);

        setDateRange([today, today]);
        fetchActivityLogs(todayStr, todayStr);
    }, [userId]);

    // Refetch when date range is fully selected
    useEffect(() => {
        if (dateRange && dateRange[0] && dateRange[1]) {
            const start = formatDate(dateRange[0]);
            const end = formatDate(dateRange[1]);
            setStartTime(start)
            setEndTime(end)
            fetchActivityLogs(start, end);
        }
    }, [dateRange]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const filteredLogs = activityLogs.filter((item) => {
        if (!searchQuery) return true;

        const q = searchQuery.toLowerCase().trim();

        return (
            (item.username || '').toLowerCase().includes(q) ||
            (item.user_full_name || '').toLowerCase().includes(q) ||
            (item.user_email || '').toLowerCase().includes(q)
        );
    });

    const sortedFilteredLogs = [...filteredLogs].sort((a, b) => {
        const countA =
            Number(a.call_data || 0) +
            Number(a.email_count || 0) +
            Number(a.sms_count || 0);

        const countB =
            Number(b.call_data || 0) +
            Number(b.email_count || 0) +
            Number(b.sms_count || 0);

        return countB - countA;
    });

    return (
        <>
            <Toast ref={toast} />

            <div
                style={{
                    backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: '100vh',
                    position: 'relative',
                }}
            >
                <div
                    className="table-inner-div"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 0,
                    }}
                />

                <FlexComponent justifyContent="center" flexWrap="wrap" style={{ padding: ".75rem " }}>
                    <FlexComponent
                        className="applicantDivs"
                        style={{ minWidth: '280px', maxWidth: '400px' }}
                        alignItems="start"
                        gap="1rem"
                    >
                        <span className="p-input-icon-left" style={{ width: '100%'}}>
                            <i className="pi pi-search" />
                            <InputText
                                type="search"
                                placeholder="Search Users"
                                value={searchQuery}
                                onChange={handleSearchChange}
                                style={{
                                    width: '100%',
                                    color: 'black',
                                    background: 'rgba(255,255,255,0.9)',
                                    minWidth: "250px" 
                                }}
                            />
                        </span>

                        <div className="applicantDivs" style={{ width: '90%' }}>
                            <Calendar
                                placeholder="Select Dates"
                                style={{ width: '100%', minWidth: "210px" }}
                                value={dateRange}
                                onChange={(e) => setDateRange(e.value)}
                                selectionMode="range"
                                readOnlyInput
                                showButtonBar
                            />
                        </div>
                    </FlexComponent>
                </FlexComponent>

                {searchQuery && (
                    <div>
                        <p
                            style={{
                                position: 'relative',
                                color: '#ccc',
                                marginTop: '.5rem',
                            }}
                        >
                            Showing {sortedFilteredLogs.length} matching user
                            {sortedFilteredLogs.length !== 1 ? 's' : ''}
                        </p>
                    </div>
                )}

                <FlexComponent flexWrap="wrap" justifyContent="center" style={{ padding: '1rem' }}>
                    {loading ? (
                        <div
                            style={{
                                width: '100%',
                                minHeight: '50vh',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <ProgressSpinner
                                style={{ width: '80px', height: '80px' }}
                                strokeWidth="5"
                                // fill="var(--surface-ground)"
                                animationDuration=".9s"
                            />
                        </div>
                    ) : sortedFilteredLogs.length > 0 ? (
                        sortedFilteredLogs.map((data) => (
                            <UserActivityLog
                                key={data.user_id || data.id || Math.random()}
                                data={data}
                                toast={toast}
                                start={startTime}
                                end={endTime}
                            />
                        ))
                    ) : searchQuery ? (
                        <div
                            style={{
                                color: 'white',
                                fontSize: '1.1rem',
                                padding: '2rem',
                                textAlign: 'center',
                                width: '100%',
                            }}
                        >
                            No users found matching "{searchQuery}"
                        </div>
                    ) : activityLogs.length === 0 ? (
                        <div
                            style={{
                                color: '#aaa',
                                fontSize: '1.1rem',
                                padding: '3rem',
                                textAlign: 'center',
                                width: '100%',
                            }}
                        >
                            No activity logs available for selected period
                        </div>
                    ) : null}
                </FlexComponent>
            </div>
        </>
    );
}

export default UserActivityLogs;